<template>
	<component :is="tag" draggable="true" @dragstart="dragstart">
		<slot />
	</component>
</template>

<script>
	export default {
		props: {
			tag: {
				type: String,
				default: 'div'
			},
			payload: {
				type: Object,
				default() {
					return {
						type: 	'none',
						data:	null
					};
				}
			}
		},
		methods: {
			dragstart(e) {
				console.log('dragstart', e, this.payload);
				e.dataTransfer.setData(this.payload.type, JSON.stringify(this.payload.data));
			}
		}
	}
</script>

<style lang="scss" scoped>

</style>